import { useEffect } from "react";

export default function useConsole(...params:any){
    useEffect(()=>{
        console.log(...params)
    },[JSON.stringify(params)])
}
